var _style, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g5, _path14, _path15, _g6, _path16, _g7, _path17, _path18, _g8, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g9, _g10, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptystate1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 745",
    width: 1000,
    height: 745,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7117863_3369472-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ebebeb } \r\n\t\t.s1 { fill: #e0e0e0 } \r\n\t\t.s2 { fill: #f5f5f5 } \r\n\t\t.s3 { fill: #ffffff } \r\n\t\t.s4 { fill: #f0f0f0 } \r\n\t\t.s5 { fill: #e6e6e6 } \r\n\t\t.s6 { fill: #fafafa } \r\n\t\t.s7 { fill: #407bff } \r\n\t\t.s8 { opacity: .2;fill: #000000 } \r\n\t\t.s9 { opacity: .2;fill: #ffffff } \r\n\t\t.s10 { opacity: .5;fill: #ffffff } \r\n\t\t.s11 { fill: none;stroke: #407bff;stroke-width: 2 } \r\n\t\t.s12 { opacity: .1;fill: #000000 } \r\n\t\t.s13 { opacity: .3;fill: #000000 } \r\n\t\t.s14 { opacity: .4;fill: #000000 } \r\n\t\t.s15 { fill: #263238 } \r\n\t\t.s16 { fill: #ed847e } \r\n\t\t.s17 { fill: #ffc3bd } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1000 655.3h-1000v-0.5h1000z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m833.6 687h66.2v0.5h-66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m645.1 692.4h17.3v0.5h-17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m793.2 668.4h38.4v0.5h-38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m104.9 671.8h86.4v0.5h-86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m209.1 671.8h12.7v0.5h-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m262.9 680.2h187.4v0.5h-187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m474 565.6h-386.2c-6.3 0-11.4-5.1-11.4-11.4v-542.9c0-6.3 5.1-11.4 11.4-11.4h386.2c6.3 0 11.4 5.1 11.4 11.4v542.9c0 6.3-5.1 11.4-11.4 11.4zm-386.2-565.2c-6 0-10.9 4.9-10.9 10.9v542.9c0 6 4.9 10.9 10.9 10.9h386.2c6 0 10.9-4.9 10.9-10.9v-542.9c0-6-4.9-10.9-10.9-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m906.6 565.6h-386.2c-6.3 0-11.4-5.1-11.4-11.4v-542.9c0-6.3 5.1-11.4 11.4-11.4h386.2c6.3 0 11.4 5.1 11.4 11.4v542.9c0 6.3-5.1 11.4-11.4 11.4zm-386.2-565.2c-6 0-10.9 4.9-10.9 10.9v542.9c0 6 4.9 10.9 10.9 10.9h386.2c6 0 10.9-4.9 10.9-10.9v-542.9c0-6-4.9-10.9-10.9-10.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m436.9 479.6h-252.8v-17.9h252.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m436.9 479.6h-109.9v-17.9h109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m221.4 654.8h-37.3v-175.2h37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m221.4 497.7l-37.3-12.8v-5.3h37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m436.9 654.8h-37.4v-175.2h37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m364.3 654.8h-37.3v-175.2h37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m364.3 497.7l-37.3-12.8v-5.3h37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m294 654.8h-37.4v-175.2h37.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m460.7 335.7h-318.7v-271.4h318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m460.7 64.3h3.5v271.4h-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m154 323.7v-247.4h294.7v247.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m297.8 286.1c17.9-60 23-148.5 61.3-136.3 38.3 12.2-11.9 143.1-11.9 143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m258.1 292.9c0 0-56.9-200.9 0-203.6 56.9-2.6 52.3 112.8 70.6 199.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m378.5 288.6c2.5 57.4-6.9 115.9-24.4 173.1h-95.4c-17.5-57.2-26.9-115.7-24.4-173.1 0.3-5.2 4.5-9.3 10-9.3h124.6c5.2 0 9.4 4.1 9.6 9.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m652.4 654.8h-7v-560.2h7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m817.4 654.8h-7v-560.2h7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m602.6 654.8h-7v-560.2h7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m767.6 654.8h-7v-560.2h7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m817.4 98.4h-221.8v-7.6h221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m817.4 235.6h-221.8v-7.7h221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m817.4 372.8h-221.8v-7.7h221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m817.4 510h-221.8v-7.7h221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m817.4 647.1h-221.8v-7.6h221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m817.4 98.4h-49.8v-7.6h49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m817.4 235.6h-49.8v-7.7h49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m817.4 372.8h-49.8v-7.7h49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m817.4 510h-49.8v-7.7h49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m817.4 647.1h-49.8v-7.6h49.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m697.8 150.2c7.1 0 12.8 5.7 12.8 12.8v64.9h-77.7v-64.9c0-7.1 5.7-12.8 12.7-12.8 7.1 0 12.8-5.7 12.8-12.8v-10.8h26.7v10.8c0 7.1 5.7 12.8 12.7 12.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m740.2 365.1h-116.8v-44.6h116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m740.2 320.5h20.4v44.6h-20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m740.2 340.4h20.4v4.9h-20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m740.2 345.3h-116.8v-4.9h116.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m708.9 639.5h-91.2v-78.9h91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m708.9 560.6h15.9v78.9h-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m708.9 595.7h15.9v8.7h-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m708.9 604.4h-91.2v-8.7h91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m708.9 586.5h15.9v3.1h-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m708.9 589.6h-91.2v-3.1h91.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m639.9 502.3h-16.5v-80.2h16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m639.9 473.7h-16.5v-23h16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m639.9 422.1h56.2v80.2h-56.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m665.4 502.3h-18.6v-90.6h18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m665.4 454.5h-18.6v-14h18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m665.4 477.8h-18.6v-14h18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m665.4 411.7h63.5v90.6h-63.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m686.2 502.3h-10v-80.2h10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m684.5 492.1h-6.6v-59.8h6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m686.2 422.1h34.2v80.2h-34.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m713.1 502.3h-11.4v-84.4h11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m713.1 457.7h-11.4v-13h11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m713.1 479.4h-11.4v-13h11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m713.1 417.9h38.6v84.4h-38.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m690.3 320.5c-13.7 0-24.9-11.1-24.9-24.9 0-13.7 11.2-24.8 24.9-24.8 13.8 0 24.9 11.1 24.9 24.8 0 13.8-11.1 24.9-24.9 24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m717.8 320.5c-9.5 0-17.2-7.7-17.2-17.2 0-9.6 7.7-17.3 17.2-17.3 9.6 0 17.3 7.7 17.3 17.3 0 9.5-7.7 17.2-17.3 17.2z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path> 356 ",
    className: "s2",
    d: "m887.8 722.5c0 12.5-173.6 22.6-387.8 22.6-214.2 0-387.8-10.1-387.8-22.6 0-12.5 173.6-22.7 387.8-22.7 214.2 0 387.8 10.2 387.8 22.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m509.1 700.1c0 7.1-5.8 12.9-12.9 12.9h-231c-7.2 0-13-5.8-13-12.9v-132.7h256.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m229.9 538.8c-2.5-3.2-0.4-5.7 4.7-5.7h163.4c5.1 0 11.2 2.5 13.6 5.7l22.4 28.6h-181.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m229.9 538.8c-2.5-3.2-0.4-5.7 4.7-5.7h163.4c5.1 0 11.2 2.5 13.6 5.7l22.4 28.6h-181.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m509.1 567.4h-181.8l22.4-18.7c2.5-2 8.5-3.7 13.6-3.7h163.5c5 0 7.1 1.7 4.7 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m509.1 700.1c0 7.1-5.8 12.9-12.9 12.9h-155.9c-7.2 0-13-5.8-13-12.9v-132.7h181.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m304.8 567.4v90.9l-6.1-4.1-5.4 4.1-4-5.5-3.8 5.5-4.4-4.9-6.3 4.9v-90.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m315.4 369l-32.3-27.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m332.2 383l-9.9-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m414.6 440.8l-128-107.5c-3.5-2.9-3.9-7.6-1-11l14-27 94-107.8 141.9 119.1-106.6 133.2c-3.4 4-10.2 4.4-14.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m379 361.4l-15.3 24.7-3.9-6.2-5-1.4-1.9-4.9-4.1-0.3-2.1-5.7-6.2-1.3 15.4-24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m530.9 302.7l-95.6 106.6-135.7-114 94-107.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m568.9 304.4l-94 107.8-39.6-2.9 95.6-106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m568.9 304.4l-94 107.8-39.6-2.9 95.6-106.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m393.6 187.5l-94 107.8-39.6-2.9 95.6-106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m393.6 187.5l-94 107.8-39.6-2.9 95.6-106.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m376.1 229.8l17.5-42.3 137.3 115.2-29.5 32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m299.6 295.3l94-107.8-17.5 42.3-66.3 74.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m564 102c0.4 1.3 0 2.6-0.8 2.8-0.9 0.2-1.8-0.6-2.2-1.9-0.4-1.3 0-2.5 0.8-2.8 0.9-0.2 1.8 0.6 2.2 1.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m567.7 116.7c0 0-3.6 2.1-6.5 0.7 2.2-4.6 2.9-12.9 2.9-12.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m566 93.5c-3.3-1.2-5.6 0.5-5.7 0.6-0.3 0.3-0.8 0.2-1.1-0.2-0.2-0.3-0.2-0.8 0.2-1.1 0.1-0.1 3-2.2 7.1-0.8 0.5 0.2 0.7 0.6 0.5 1q-0.1 0.3-0.3 0.5-0.3 0.1-0.7 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m608.5 110.6c0.9 10.6 3.5 30 9.7 34.4 0 0-1.4 12.8-23.9 16.1-24.7 3.6-13.6-10.5-13.6-10.5 13-5.2 11.2-15.2 7.5-24.2l9.5-10.9c3.6-4.1 10.3-10.4 10.8-4.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m578.4 158c0 0-2.1-4.9 0.8-9.4 9.9-8.5 36.2-11.2 42.6-8.5 2.5 1 6.5 8.3 4.5 10.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m710.2 684.8c-1.7 0.5-3.3 0.8-4.2 0.1-0.3-0.2-0.7-0.7-0.5-1.8q0.2-0.8 0.9-1.2c2.2-1.3 7.5 0.4 7.7 0.5 0.2 0 0.3 0.2 0.3 0.3 0 0.2-0.1 0.3-0.2 0.4-0.8 0.4-2.4 1.2-4 1.7zm-2.9-2.4q-0.3 0.1-0.5 0.2-0.4 0.2-0.5 0.7c-0.2 0.7 0.1 0.9 0.2 1 0.9 0.7 4.2-0.3 6.5-1.4-1.7-0.5-4.3-1-5.7-0.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m714.1 683.1q-0.1 0.1-0.2 0c-1.9-0.4-6.2-2.9-6.4-4.7 0-0.4 0.1-1 0.9-1.4q0.9-0.4 1.8 0c2.3 0.9 4.1 5.4 4.2 5.6q0 0.2-0.1 0.4-0.1 0.1-0.2 0.1zm-5.2-5.4q-0.1 0-0.2 0c-0.4 0.2-0.4 0.5-0.4 0.6 0.1 1.1 3 3.1 5 3.8-0.6-1.3-1.9-3.8-3.4-4.4q-0.5-0.2-1 0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m593 706.3c-2.2 0-4.2-0.3-4.9-1.3-0.3-0.3-0.5-0.9 0-1.7q0.4-0.7 1.2-0.9c2.8-0.8 8.7 2.6 8.9 2.7 0.1 0.1 0.2 0.2 0.2 0.4 0 0.2-0.2 0.3-0.3 0.3-1.1 0.2-3.1 0.5-5.1 0.5zm-2.7-3.2q-0.4 0-0.7 0.1-0.6 0.1-0.8 0.5c-0.3 0.5-0.2 0.7-0.1 0.9 0.8 1.1 5 1.1 8.1 0.6-1.5-0.8-4.5-2.1-6.5-2.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m598 705.8q-0.1 0-0.2 0c-2-0.9-6-4.5-5.7-6.4 0.1-0.4 0.4-1 1.5-1.1q1.2-0.1 2.2 0.7c2.1 1.7 2.6 6.2 2.6 6.4q0 0.2-0.2 0.4-0.1 0-0.2 0zm-4.1-6.7q-0.1 0-0.2 0c-0.7 0.1-0.8 0.3-0.8 0.4-0.2 1.2 2.6 4 4.6 5.2-0.2-1.3-0.8-4-2.2-5.1q-0.6-0.5-1.4-0.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m616.4 705.4h-16.7l-1.7-38.6h16.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m733.7 679.1l-15.4 5.3-16-36.5 15.4-5.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m714.6 680.5l17.9-5.5c0.7-0.2 1.4 0.1 1.7 0.7l7.5 13.2c0.8 1.4 0.1 3.1-1.4 3.6-6.3 1.8-9.5 2.4-17.3 4.8-4.9 1.5-17.1 6.1-24 7.5-6.7 1.3-9.1-5.2-6.4-6.4 12-5.3 16.9-11.3 19.7-16.1 0.6-0.8 1.4-1.5 2.3-1.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m599.8 703.5h18.2c0.7 0 1.3 0.5 1.4 1.1l3.3 14.9c0.4 1.5-0.8 3-2.4 2.9-6.6-0.1-16.1-0.5-24.3-0.5-9.7 0-13.7 0.6-25.1 0.6-6.8 0-8.7-6.9-5.9-7.6 13.1-2.8 19.5-3.1 30.8-10.1 1.2-0.7 2.5-1.3 4-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m648.3 155.7c4.8 4.4 9 8.9 13.4 13.6 4.2 4.6 8.4 9.4 12.3 14.6 4 5.1 7.7 10.4 11.1 16.5 1.7 3 3.4 6.2 4.7 9.8 0.4 1 0.7 1.9 1 2.9 0.3 1 0.6 2 0.8 3.1l0.3 1.7 0.3 1.8c0.1 0.9 0.3 3.4 0 5.1-0.5 3.8-2 6.7-3.5 8.9-1.4 2.2-3 3.9-4.6 5.3-3.1 2.9-6.1 4.9-9.1 6.7-6 3.5-12 6-17.9 8.3-12 4.5-24 7.7-36.4 10l-3.5-12c10.9-4.7 21.9-9.8 32.1-15.2 5-2.7 10-5.7 14.2-8.8 2-1.5 3.9-3.1 5.2-4.6 0.6-0.7 1-1.3 1.1-1.7 0.2-0.3 0-0.3-0.2 0.5-0.1 1.3-0.1 0.3-0.4-0.5-0.1-0.3-0.3-0.8-0.5-1.2-0.1-0.4-0.4-0.9-0.6-1.4-0.9-2-2.2-4.2-3.6-6.4-2.9-4.3-6.4-8.8-10-13.2-3.7-4.3-7.6-8.7-11.5-12.9-3.9-4.3-8.2-8.6-12.1-12.6z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m627.4 259.8c-2.1 7.9-11.4 11.7-11.4 11.7l-10.1-16.6 15.8-4.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m605.9 254.9l10.1 16.6-10.2 3-6.2-13.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m652.3 153.2c17.3 11.1 24 25.5 24 25.5l-32.6 22.3c0 0-33.8-24.8-32.3-40.8 1.9-19.9 22.2-19 40.9-7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m652.3 153.2c17.3 11.1 24 25.5 24 25.5l-32.6 22.3c0 0-33.8-24.8-32.3-40.8 1.9-19.9 22.2-19 40.9-7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m580.7 150.6c9.8-2.4 26.2-4.4 37.5-5.6 2.7-0.2 5.3-0.4 7.9-0.5 11.8-0.6 21.7 8.8 21.8 20.6 0.5 58.2 15.2 111.4 16.5 123.6l-88.3 13c-34.7-120.3-20.1-142.8-20.1-142.8 0 0 11.8-5.2 24.7-8.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m580.7 150.6c9.8-2.4 26.2-4.4 37.5-5.6 2.7-0.2 5.3-0.4 7.9-0.5 11.8-0.6 21.7 8.8 21.8 20.6 0.5 58.2 15.2 111.4 16.5 123.6l-88.3 13c-34.7-120.3-20.1-142.8-20.1-142.8 0 0 11.8-5.2 24.7-8.3z"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m553.8 197.6l0.3-0.3 20.8 1.8c3.2 13.4-8.4 31.7-14.5 40.2-3.5-17.2-5.5-30.9-6.6-41.7z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m614.7 666.8l0.9 19.9h-16.7l-0.9-19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m725.9 661.4l-15.3 5.3-8.3-18.8 15.4-5.3z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m606.3 86.6c3.7 16.2 6.6 25.4 1 35.9-8.4 15.8-30.1 14.3-38.6-0.4-7.5-13.3-12.3-37.4 1.4-48.3 13.4-10.7 32.5-3.3 36.2 12.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m573.9 102.5l-6.2 3.7 0.6-21c0 0-6.4 0.5-11.1-3.2 2.2-2.1 36.8-14.2 47.6-12.1 1.1-0.5 2.4-2.6 2.4-2.6 0 0 0.5 2.7-1.4 3.7 1.4-0.3 4.7 0.3 5.6 2.3-2.9-0.6-4.6 0.2-4.6 0.2 0 0 12.1 1.9 7.7 18.5-4.7 18.3-3.2 28.9-3.2 28.9 0 0-8.9 6.9-16.6 5.6-8.3-9.1-20.3-20.1-20.8-24z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m562.1 80.3c-9.7 0.1-13.2-4.7-15.7-8.7 7-0.8 21.6-5.3 32.4-6 10.8-0.8 22.7 1.2 19.1 5.9-3.6 4.7-35.8 8.8-35.8 8.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m564.3 76c-8-1.1-15.8-8.7-9.8-15.9 2.2 5.3 17.2 4.7 27.8 2.5 13.9-2.9 23.7 1.8 18.7 11.3-2.7 5.2-36.7 2.1-36.7 2.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m582.5 97.7c1.3 4.1 0.8 8.7-0.5 12-2 5-6.4 4-8.8-0.3-2-4-3.5-11.3-0.1-14.9 3.4-3.6 8-1.6 9.4 3.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m664.4 288.7c0 0 10.5 126.6 17.8 182.8 9.5 73.1 45.5 180.5 45.5 180.5l-28 9.7c0 0-56.2-142.6-67.6-194.9-10.4-47.8-24.7-169.7-24.7-169.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m727.1 644.4l3.8 9.7-32.7 10.6c0 0-5.8-11.9-5.7-11.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m615.3 359.6c4.5 33.9 10.2 74 15.3 99.7 7.3-39.4 9.1-88.9-15.3-99.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m639.6 292.3c0 0-21.3 122.2-22.6 178.9-1.3 51.9 3.9 211.7 3.9 211.7h-28.3c0 0-24.7-162.9-26.6-215.8-1.8-50.9 10.1-165.4 10.1-165.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m624.1 672.9l-0.9 10.4h-34.4c0 0-1.7-11.7-1.6-11.7z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m570.6 187c-3.1 5-6.3 9.5-9.5 14-3.3 4.6-6.8 9-10.3 13.4-7 8.8-14.6 17.3-23.1 25.3-2.2 1.9-4.3 3.9-6.7 5.8l-1.8 1.4-0.9 0.7c-0.3 0.3-0.4 0.4-1.1 0.9-2.2 1.6-4.4 2.6-6.4 3.3-4.1 1.4-7.7 1.8-11.1 1.9-3.4 0.2-6.5-0.1-9.5-0.4-12.2-1.5-22.9-4.9-33.5-9.5l3.4-12c10.4 1 21.2 1.9 30.9 1.5 2.4-0.2 4.7-0.4 6.8-0.8 2-0.3 3.9-0.9 4.8-1.5 0.5-0.3 0.8-0.5 0.7-0.6-0.1 0.1 0.3-0.2 0.5-0.4l0.6-0.6 1.4-1.3c1.8-1.6 3.5-3.5 5.2-5.3 3.5-3.7 6.9-7.5 10.2-11.6 3.3-4 6.6-8.1 9.8-12.3 3.2-4.2 6.3-8.5 9.4-12.8 3.1-4.2 6.1-8.7 9-12.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m582.2 181.7c6.8 22-32.3 46.4-32.3 46.4l-25.3-32.3c0 0 7-14.2 21-29.4 17.2-18.7 31.5-1.4 36.6 15.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m582.2 181.7c6.8 22-32.3 46.4-32.3 46.4l-25.3-32.3c0 0 7-14.2 21-29.4 17.2-18.7 31.5-1.4 36.6 15.3z"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m466 243.3c-7.7 9.3-18.4 3.4-18.4 3.4l-2.2-17.8 20.6 3.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m445.4 228.9l2.2 17.8-5.6-1-4.5-12.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystate1);
export default __webpack_public_path__ + "static/media/emptystate1.a960a6e30115c2f1bd35b2fec8e44ef9.svg";
export { ForwardRef as ReactComponent };